import { render, staticRenderFns } from "./CspaceLikeBtn.vue?vue&type=template&id=74d7ca0f&"
import script from "./CspaceLikeBtn.vue?vue&type=script&lang=js&"
export * from "./CspaceLikeBtn.vue?vue&type=script&lang=js&"
import style0 from "./CspaceLikeBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports